import { tacticMap } from '../../../../../../../../../classes/tactics/tacticKeys';
import { colors } from '../../../../../../../../../colorVars';
import { DownArrow } from '../../../../../../../../../components/atomic/atomicComponentLibrary/icons/downArrow/DownArrow';
import { UpArrow } from '../../../../../../../../../components/atomic/atomicComponentLibrary/icons/upArrow/UpArrow';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import { formatDisplayPrice } from '../../../../../../../../../utils/math/formatDisplayPrice';
import { individualTacticTriggeredBuilderMap } from './individualTacticTriggeredBuilders/individualTacticTriggeredBuilderMap';

export function tacticTriggerBuilder({ parsedStatusObj }) {
  const tacticName = parsedStatusObj.tacticName;
  const individualTacticBuilder =
    individualTacticTriggeredBuilderMap[tacticName] ?? null;
  if (individualTacticBuilder) {
    return individualTacticBuilder(parsedStatusObj);
  }
  const triggerPrice = parsedStatusObj.triggerPrice;
  const tradeDirection = parsedStatusObj.tradeDirection;
  return (
    <td>
      <div style={{ display: 'flex'}}>
        <Body3 margin="4px 0 0 0" fontWeight={500} color={colors.lightGrey}>
          Tactic: {tacticName ? tacticMap[tacticName].tacticLabel : 'unknown'}.
          Trigger price:{' '}
          {formatDisplayPrice(triggerPrice)}
        </Body3>
        {tradeDirection ? (
          tradeDirection === 'LONG' ? (
            <UpArrow size={15} margin="4px 5px 0 5px" />
          ) : (
            <DownArrow size={15} margin="4px 5px 0 5px" />
          )
        ) : null}
      </div>
    </td>
  );
}
